import { map, take } from 'rxjs/operators';
import { Roles } from 'src/app/model';
import * as i0 from "@angular/core";
import * as i1 from "../service/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "../service/user.service";
export class RoleGuard {
    constructor(_auth, _router, userService) {
        this._auth = _auth;
        this._router = _router;
        this.userService = userService;
        this.roles = Roles;
    }
    canActivate(next, state) {
        return this.userService.userInfo$.pipe(take(1), map((userInfo) => {
            const requiredRoles = next.data.rolUsuario;
            const userRole = userInfo.rol;
            const hasPermission = requiredRoles.some((requiredRole) => requiredRole === userRole);
            if (hasPermission) {
                return true;
            }
            else {
                console.warn(`Access denied for role: ${userRole}. Required roles: ${requiredRoles.join(', ')}`);
                return this._router.createUrlTree(['/peticiones/seguimiento']);
            }
        }));
    }
}
RoleGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleGuard_Factory() { return new RoleGuard(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.UserService)); }, token: RoleGuard, providedIn: "root" });
